import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import PermisosListSelect from "../Permisos/PermisosListSelect.js"
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"

import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';

var TabHeaderStyle = {
    marginTop: '-15px',
    marginRight: '-15px',
    marginBottom: '0px',
    marginLeft: '-15px',
};

var TabHeaderBody = {
    marginTop: '0px',
    marginRight: '-15px',
    marginBottom: '-15px',
    marginLeft: '-15px',
};

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 1,
            grupo_id: null,
            permisos_checked: [],
            permisos_disabled: [],
            departamento_id: null,
            departamentopadre_id: null,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
    }


    ResetForm() {
        this.setState({
            activeTab: 1,
            grupo_id: null,
            permisos_checked: [],
            permisos_disabled: [],
            departamento_id: null,
            departamentopadre_id: null,
        });
    }

    getActiveClass(tabN) {
        if (this.state.activeTab == tabN)
            return "active";
        else
            return "";
    }

    toggleTab(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    groupChanged(value) {
        if (value) {
            this.setState({
                grupo_id: value.pk,
                permisos_disabled: value.permisos,
                permisos_checked: [],
            });
        } else {
            this.setState({
                grupo_id: null,
                permisos_disabled: [],
                permisos_checked: [],
            });
        }
    }



    render() {
        return (
            <ParadigmaModal
                postUrl={api.usuarios.usuarios.create}
                onSubmit={() => this.props.onSubmit()}
                successMessage={"El Usuario ha sido creado con éxito."}
                title={"Nuevo Usuario"}
                buttonTitle={"Nuevo Usuario"}
                buttonIcon={"fa fa-plus fa-lg"}

                saveButton={true}
                closeButton={true}
                onClose={() => this.ResetForm()}
            >
                <Nav tabs style={TabHeaderStyle}>
                    <NavItem>
                        <NavLink className={this.getActiveClass(1)} onClick={() => { this.toggleTab(1); }}>
                            Usuario
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={this.getActiveClass(2)} onClick={() => { this.toggleTab(2); }}>
                            Permisos
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent style={TabHeaderBody} activeTab={this.state.activeTab} className={"py-2"}>
                    <TabPane tabId={1} className="py-0">
                        <Row>
                            <Col className="col-2">
                                <Label>Apellido</Label>
                            </Col>
                            <Col className="col-10">
                                <Input type="text" name="apellido"></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </Col>
                        </Row>
                        <Row className="mt-1">
                            <Col className="col-2">
                                <Label>Nombre</Label>
                            </Col>
                            <Col className="col-10">
                                <Input type="text" name="nombre"></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </Col>
                        </Row>
                        <Row className="mt-1">
                            <Col className="col-2">
                                <Label>DNI</Label>
                            </Col>
                            <Col className="col-10">
                                <Input type="text" name="dni"></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </Col>
                        </Row>
                        <Row className="mt-1">
                            <Col className="col-2">
                                <Label>Domicilio</Label>
                            </Col>
                            <Col className="col-10">
                                <Input type="text" name="domicilio"></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </Col>
                        </Row>
                        <Row className="mt-1">
                            <Col className="col-2">
                                <Label>Email</Label>
                            </Col>
                            <Col className="col-10">
                                <Input type="text" name="email"></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </Col>
                        </Row>
                        <Row className="mt-1">
                            <Col className="col-2">
                                <Label>Teléfono</Label>
                            </Col>
                            <Col className="col-10">
                                <Input type="text" name="telefono"></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </Col>
                        </Row>


                        <Row className="mt-1">
                            <Col className="col-2">
                                <Label>Grupo</Label>
                            </Col>
                            <Col className="col-10">
                                <ParadigmaAsyncSeeker
                                    fieldName={""}
                                    url={api.usuarios.grupos.select}
                                    onChange={(data) => this.setState({ departamentopadre_id: (data != null ? data.pk : 0), departamento_id: null })}
                                    value={this.state.departamentopadre_id} />
                                <FormFeedback className="col-12"></FormFeedback>
                            </Col>
                        </Row>

                        <Row className="mt-1">
                            <Col className="col-2">
                                <Label>Subgrupo</Label>
                            </Col>
                            <Col className="col-10">
                                <ParadigmaAsyncSeeker
                                    disabled={!this.state.departamentopadre_id}
                                    fieldName={"departamento_id"}
                                    url={api.usuarios.subgrupos.select + (this.state.departamentopadre_id ? "?grupo=" + this.state.departamentopadre_id : "")}
                                    onChange={(data) => this.setState({ departamento_id: (data != null ? data.pk : 0) })}
                                    value={this.state.departamento_id} />
                                <FormFeedback className="col-12"></FormFeedback>
                            </Col>
                        </Row>

                        <Row className="mt-2">
                            <Col className="col-12">
                                <Label className="w-100 text-center">Datos de Login</Label>
                            </Col>
                        </Row>

                        <Row className="mt-1">
                            <Col className="col-2">
                                <Label>Usuario</Label>
                            </Col>
                            <Col className="col-10">
                                <Input type="text" name="username"></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </Col>
                        </Row>
                        <Row className="mt-1">
                            <Col className="col-2">
                                <Label>Contraseña</Label>
                            </Col>
                            <Col className="col-10">
                                <Input type="password" name="password"></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </Col>
                        </Row>
                        <Row className="mt-1">
                            <Col className="col-2">
                                <Label>Repetir Contraseña</Label>
                            </Col>
                            <Col className="col-10">
                                <Input type="password" name="password2"></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </Col>
                        </Row>
                    </TabPane>
                    <TabPane tabId={2} className="py-0">
                        <Row>
                            <Col className="col-12">
                                <Label>Perfil de Usuario</Label>
                            </Col>
                            <Col className="col-12">
                                <ParadigmaAsyncSeeker onChange={(value) => this.groupChanged(value)} fieldName={"grupo_id"}
                                    url={api.usuarios.perfiles.select} value={this.state.grupo_id} />
                            </Col>
                        </Row>
                        <Row className="mt-1">
                            <Col className="col-12">
                                <Label>Permisos</Label>
                                <PermisosListSelect disabledNodes={this.state.permisos_disabled} onChange={(value) => this.setState({ permisos_checked: value })} checked={this.state.permisos_checked} fieldName={"permisos"} />
                            </Col>
                        </Row>
                    </TabPane>
                </TabContent>

            </ParadigmaModal>
        );
    }
}

export default Create;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Usuarios/Create.js